import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';

import { saveBrowserCheckCookie } from '@app/helpers/cookies';
import { NAMESPACE } from '@app/i18n';

import ErrorSplashScreen from './ErrorBoundary/error-splash-screen';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import router from './Routes/routes';

export const IEWarning = () => {
  const { t } = useTranslation(NAMESPACE.APP_SHELL);

  return (
    <div
      data-test="ie-warning"
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '1rem',
        backgroundColor: '#e6f3ff',
        border: '1px solid #b3d9ff',
        borderRadius: '4px',
        margin: '1rem',
        color: '#0066cc',
      }}
    >
      <p>
        <Trans
          t={t}
          i18nKey="unsupportedBrowser.message"
          components={[
            <a
              key="chat-link"
              href="https://chat.marley.ai"
              aria-label="chat.marley.ai"
              style={{ color: '#0066cc', textDecoration: 'underline' }}
            />,
          ]}
        />
      </p>
    </div>
  );
};

const Root = () => {
  useEffect(() => {
    saveBrowserCheckCookie(true);
  }, []);

  const ua = window.navigator.userAgent;
  const isIE = ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1;

  return (
    <div className="root">
      <ErrorBoundary errorMessage={<ErrorSplashScreen />}>
        {isIE ? <IEWarning /> : <RouterProvider router={router} />}
      </ErrorBoundary>
    </div>
  );
};

export default Root;
